import _defineProperty from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "width", "height"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// src/arrow.tsx
import * as React from "react";
import { Primitive } from "@radix-ui/react-primitive";
import { jsx } from "react/jsx-runtime";
var NAME = "Arrow";
var Arrow = React.forwardRef(function (props, forwardedRef) {
  var children = props.children,
    _props$width = props.width,
    width = _props$width === void 0 ? 10 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 5 : _props$height,
    arrowProps = _objectWithoutProperties(props, _excluded);
  return /* @__PURE__ */jsx(Primitive.svg, _objectSpread(_objectSpread({}, arrowProps), {}, {
    ref: forwardedRef,
    width: width,
    height: height,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none",
    children: props.asChild ? children : /* @__PURE__ */jsx("polygon", {
      points: "0,0 30,0 15,10"
    })
  }));
});
Arrow.displayName = NAME;
var Root = Arrow;
export { Arrow, Root };